export const toAppliedAgreementIds = (selected)=>selected.map((option)=>option.id);
